import { render, staticRenderFns } from "./ClaimAccountRequest.vue?vue&type=template&id=8ac77d18"
import script from "./ClaimAccountRequest.vue?vue&type=script&lang=ts"
export * from "./ClaimAccountRequest.vue?vue&type=script&lang=ts"
import style0 from "./ClaimAccountRequest.vue?vue&type=style&index=0&id=8ac77d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports